import { render } from "./CopyReview.vue?vue&type=template&id=2c45ac24&scoped=true"
import script from "./CopyReview.vue?vue&type=script&lang=js"
export * from "./CopyReview.vue?vue&type=script&lang=js"

import "./CopyReview.vue?vue&type=style&index=0&id=2c45ac24&lang=scss&scoped=true"
import "./review.scss?vue&type=style&index=1&id=2c45ac24&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c45ac24"]])

export default __exports__